import createHistory from 'history/createBrowserHistory';
export default createHistory();


// WEBPACK FOOTER //
// ./src/router/history.js